import dynamic from 'next/dynamic';
import React, { ReactElement } from 'react';

import { useDealerSearch } from '@/components/hooks/useDealerSearch';
import CustomMetatag from '@/components/layouts/custom-metatag';
import Layout from '@/components/layouts/lcv';
import { Dealer } from '@/components/sections/dealer';
import { STATIC_CONTENT } from '@/contents/dealer';
import { getProvince } from '@/services/contentstack';
import { IVehicleType } from '@/types/services/contentstack';

const FooterLCVGroup = dynamic(
  () => import('@/components/layouts/lcv/footer-group'),
  {
    ssr: false,
  }
);

const META_TITLE =
  'ค้นหาผู้จำหน่ายอีซูซุ - อีซูซุประเทศไทย Isuzu Thailand Official';
const META_DESCRIPTION =
  'ค้นหาผู้จำหน่ายอีซูซุใกล้บ้านคุณได้ที่นี่ ผู้จำหน่ายอีซูซุ ค้นหาจากจังหวัด อำเภอ เขต ค้นหาจากชื่อผู้จำหน่าย โชว์รูม ศูนย์บริการ ศูนย์บริการซ่อมสีและตัวถัง';

interface LcvDealerPageProps {
  entries: any[];
  vehicleType: IVehicleType;
}

export async function getStaticProps() {
  const resProvince = await getProvince();
  const data: LcvDealerPageProps = {
    entries: resProvince.data.entries,
    vehicleType: process.env.NEXT_PUBLIC_WEB as IVehicleType,
  };
  return {
    props: data,
  };
}

const Page = (props: LcvDealerPageProps) => {
  const dealerSearchData = useDealerSearch({
    provinceOptions: props.entries,
    vehicleType: props.vehicleType,
  });

  return (
    <>
      <CustomMetatag title={META_TITLE} description={META_DESCRIPTION} />
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Dealer
        staticContent={STATIC_CONTENT}
        vehicleType={props.vehicleType}
        provinces={props.entries}
        {...dealerSearchData}
      />
      <FooterLCVGroup />
    </>
  );
};

export default Page;

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};
